import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { myList } from "../utils/my-products"
import { makeStyles } from "@material-ui/core/styles"
import List from "@material-ui/core/List"
import Entry from "./entry"
import { sort } from "ramda"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    paddingTop: 0,
  },
  inline: {
    display: "inline",
  },
}))

//return <pre>{JSON.stringify(list, null, 4)}</pre>
// return <pre>{JSON.stringify(theList, null, 4)}</pre>

const ListaDeCategoriasYProductos = ({ slug, avatares }) => {
  const data = useStaticQuery(graphql`
    {
      allMdx(filter: { fileAbsolutePath: { regex: "//productos//" } }) {
        edges {
          node {
            frontmatter {
              puesto
              title
              subtitle
              avatar
              galeria {
                descripcion
                source {
                  childImageSharp {
                    fixed {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              imagen {
                descripcion
                source {
                  childImageSharp {
                    fixed {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            slug
            excerpt(truncate:true)
            id
          }
        }
      }
    }
  `)
  const classes = useStyles()
  const compare = (a, b) => {
    const xa = a.frontmatter.puesto
    const xb = b.frontmatter.puesto
    return xa - xb
  }
  const list = data.allMdx.edges.map(x => x.node)
  const me = list.find(x => x.slug === slug) || { slug: "/" }
  const theList = sort(compare, myList(me, list))
  return (
    <div>
      <List className={classes.root}>
        {theList.map(item => (
          <Entry key={item.id} item={item} avatares={avatares} list={list}/>
        ))}
      </List>
    </div>
  )
}

export default ListaDeCategoriasYProductos
